
import { StyleSizeType, StyleColorSchemeType, StylePositionType } from '@/ui-kit/styles/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { Representor } from '@/components/page-specific/commission-calculator/enums';
import Button from '@/ui-kit/components/button';

export default {
  name: 'RepresentorSelection',
  components: {
    Typography,
    Button,
  },
  props: {
    userType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      Representor,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      TypographyType,
      representationTab: Representor.Bode,
    };
  },
  computed: {
    bodeActive() {
      return this.representationTab === Representor.Bode
        ? StyleColorSchemeType.Secondary
        : StyleColorSchemeType.White;
    },
    agentActive() {
      return this.representationTab === Representor.Agent
        ? StyleColorSchemeType.Secondary
        : StyleColorSchemeType.White;
    },
  },
  mounted() {
    this.handleRepresentorButtonClick(Representor.Bode);
  },
  methods: {
    handleRepresentorButtonClick(selection) {
      this.representationTab = selection;
      this.$emit('selection', selection);
    },
  },
};
